import { DEFAULT_LABEL_BACKGROUND_COLOR } from './SelectTags.constants'

export function getLabelBGColor(color) {
  return color || DEFAULT_LABEL_BACKGROUND_COLOR
}

export function getLabelTextColor(color) {
  return !color ? 'var(--main-text-color)' : undefined
}
